/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetHouseOfferHistoryDesktopModel,
  IGetHouseOfferHistoryDesktopRequest,
  IMappers,
  IGetHouseOfferHistoryDesktopResponse,
  IGetHouseOfferHistoryDesktopResponseError,
  TGetHouseOfferHistoryDesktopResponse,
} from './types';

const defaultConfig: TGetHouseOfferHistoryDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'valuation-offer-history',
  pathApi: '/v2/get-house-offer-history-desktop/',
  hostType: 'api',
} as TGetHouseOfferHistoryDesktopModel;

function createGetHouseOfferHistoryDesktopModel(
  parameters: IGetHouseOfferHistoryDesktopRequest,
): TGetHouseOfferHistoryDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetHouseOfferHistoryDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetHouseOfferHistoryDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetHouseOfferHistoryDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetHouseOfferHistoryDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetHouseOfferHistoryDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetHouseOfferHistoryDesktopModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetHouseOfferHistoryDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetHouseOfferHistoryDesktopResponseError);
    }
  }

  return { response, statusCode } as TGetHouseOfferHistoryDesktopResponse;
}

export { defaultConfig, createGetHouseOfferHistoryDesktopModel, fetchGetHouseOfferHistoryDesktop };
